module.exports = __webpack_public_path__ + "images/piaggio4e57b328d41f8ff66f2fb77b2ba1e445.png";